import { render, staticRenderFns } from "./LastStep_Return.vue?vue&type=template&id=2237b9e6&scoped=true&"
import script from "./LastStep_Return.vue?vue&type=script&lang=js&"
export * from "./LastStep_Return.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2237b9e6",
  null
  
)

export default component.exports